/*
 * @fileOverView Addthis component definition
 */


export default {

  mounted() {
    this.handleSocialSharing();
  },

  methods: {
    /**
     * Handles sharing content via social media.
     */
    handleSocialSharing() {
      if (typeof addthis !== 'undefined') {
        addthis.share({
          'container_selector':'.js-share-subcontrols',
          'button_selector': '.js-share-subbutton'
        });
      }
    }
  }
};
